import React from "react";
import { Link } from "react-router-dom";
import { FromInt, numberSpace } from "../../helpers/NumberTools";

//icon
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import PhoneIcon from "@mui/icons-material/Phone";
import PersonIcon from "@mui/icons-material/Person";

const OrderCard = (props) => {
  const { order } = props;
  return (
    <div className="row cards">
      <div className="col-12">
        <PersonIcon className="m-1" /> {FromInt(`${order.recipientsName}`)}
      </div>
      <div className="col-12 ">
        <PhoneAndroidIcon className="m-1" />{" "}
        {FromInt(`${order.recipientsMobiles}`)}
      </div>
      <div className="col-12  ">
        <PhoneIcon className="m-1" /> {FromInt(`${order.recipientsPhone}`)}
      </div>
      <div className="col-12 ">
        <AttachMoneyIcon className="m-1" />{" "}
        {FromInt(numberSpace(`${order.price}`))} تومان
      </div>
      <div className="col-12 ">
        <Link
          to={`/order/${order.id}`}
          className="btn btn-primary w-100 d-flex justify-content-between align-items-center"
        >
          {order.statusTxt}
          <span className="badge badge-warning position-relative sabad_card-totalprice">
            {FromInt(numberSpace(`${order.price}`))} تومان{" "}
          </span>
        </Link>
      </div>
    </div>
  );
};

export default OrderCard;
